class StoreForm {
  constructor (
    id = undefined,
    name,
    jsonSchema,
    enabled,
    createdAt,
    formTypeId = undefined,
    sequence = undefined,
    formType = undefined
  ) {
    this.id = id
    this.name = name
    this.jsonSchema = jsonSchema
    this.configuration = null
    this.enabled = enabled
    this.createdAt = createdAt ? new Date(createdAt) : undefined
    this.formTypeId = formTypeId
    this.sequence = sequence
    this.formType = formType
  }

  toNormalizedRESTModel () {
    const model = {
      // id is read-only
      name: this.name,
      jsonSchema: typeof this.jsonSchema === 'string'
        ? this.jsonSchema
        : JSON.stringify(this.jsonSchema),
      enabled: this.enabled
      // createdAt, formTypeId are read-only on update
    }
    if (this.sequence !== undefined && this.sequence !== null) {
      model.sequence = this.sequence
    }
    return model
  }

  toCreateRESTModel () {
    return {
      ...this.toNormalizedRESTModel(),
      formTypeId: this.formTypeId
    }
  }

  static FromNormalizedRESTModel ({
    id,
    name,
    jsonSchema,
    enabled,
    createdAt,
    formTypeId,
    sequence,
    formType
  }) {
    return new StoreForm(
      id,
      name,
      jsonSchema,
      enabled,
      createdAt,
      formTypeId ?? formType?.id,
      sequence ?? formType?.sequence,
      formType
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name,
      jsonSchema: this.jsonSchema,
      enabled: this.enabled,
      createdAt: this.createdAt,
      formTypeId: this.formTypeId,
      sequence: this.sequence,
      formType: this.formType
    }
  }

  static FromJSON ({
    id,
    name,
    jsonSchema,
    enabled,
    createdAt,
    formTypeId,
    sequence,
    formType
  }) {
    return new StoreForm(
      id,
      name,
      jsonSchema,
      enabled,
      createdAt,
      formTypeId,
      sequence,
      formType
    )
  }
}

export default StoreForm
